import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  constructor() {}

  setData(forSession: boolean, storeName: string, data: any, key?: string, skipIfExists?: boolean) {
    let _baseData: any;
    const storeTarget = this.getStoreTarget(forSession);

    if (this.validateJSON(storeTarget.getItem(storeName))) {
      _baseData = JSON.parse(storeTarget.getItem(storeName));
    }

    let skippable: boolean;
    if (!_baseData) {
      _baseData = {};
      _baseData[storeName] = {};

      if (!key) {
        _baseData = data;
      } else {
        _baseData[storeName][key] = data;
      }
    } else {
      if (!key) {
        if (_baseData && !skipIfExists) {
          _baseData = data;
        } else {
          skippable = true;
        }
      } else {
        if (!_baseData[storeName]) {
          _baseData[storeName] = {};
        }

        if (_baseData[storeName][key] && !skipIfExists) {
          _baseData[storeName][key] = data;
        } else {
          skippable = true;
        }
      }
    }
    if (!skippable) {
      storeTarget.setItem(storeName, JSON.stringify(_baseData));
    }
  }

  getData(forSession: boolean, storeName: string, key?: string) {
    let _baseData: any;
    const storeTarget = this.getStoreTarget(forSession);

    if (storeTarget.getItem(storeName)) {
      _baseData = JSON.parse(storeTarget.getItem(storeName));

      if (_baseData && key) {
        // return _baseData[storeName][key];
        return _baseData[key];
      }

      return _baseData;
    }

    return false;
  }

  getStoreTarget(forSession: boolean) {
    let storeTarget: any;

    if (forSession) {
      storeTarget = sessionStorage;
    } else {
      storeTarget = localStorage;
    }
    return storeTarget;
  }

  removeData(forSession: boolean, storeName: string, key?: string) {
    const storeTarget = this.getStoreTarget(forSession);
    let _baseData: any;

    if (!key) {
      storeTarget.removeItem(storeName);
    } else {
      _baseData = JSON.parse(storeTarget.getItem(storeName));

      if (_baseData && _baseData[key]) {
        delete _baseData[key];
      }

      storeTarget.setItem(storeName, JSON.stringify(_baseData));
    }
  }

  updateData(forSession: boolean, storeName: string, key?: string, data?: any) {
    const storeTarget = this.getStoreTarget(forSession);
    let _baseData: any;
    if (!key) {
      storeTarget.setItem(storeName, data);
    } else {
      _baseData = JSON.parse(storeTarget.getItem(storeName));
      if (_baseData) {
        _baseData[key] = data;
        storeTarget.setItem(storeName, JSON.stringify(_baseData));
      }
    }
  }

  wipeData(forSession: boolean) {
    const storeTarget = this.getStoreTarget(forSession);

    storeTarget.clear();
  }

  validateJSON(jsonString: string) {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e) {}
    return false;
  }

  // todo: move to helper service
  setDeepProperty(obj: any, keys: any, val: any) {
    keys = keys.split('.');
    while (keys.length > 1) {
      obj = obj[keys.shift()];
    }
    return (obj[keys.shift()] = val);
  }

  getPreferenceFromSession(userId: string, preferenceID: any, appID: string) {
    const sessionPreferences = this.getData(true, userId, 'sessionPreferences');
    if (sessionPreferences) {
      const prefIndex = sessionPreferences.findIndex(obj => obj.appID === appID && obj.preferenceID === preferenceID);
      if (prefIndex > -1) {
        return sessionPreferences[prefIndex].value;
      }
    }
  }

  savePreferenceToSession(userId: string, preferenceID: any, appID: string, value: any) {
    let sessionPreferences = this.getData(true, userId, 'sessionPreferences');
    if (sessionPreferences) {
      const prefIndex = sessionPreferences.findIndex(obj => obj.appID === appID && obj.preferenceID === preferenceID);
      if (prefIndex > -1) {
        sessionPreferences[prefIndex].value = value;
        this.updateData(true, userId, 'sessionPreferences', sessionPreferences);
      } else {
        sessionPreferences.push({
          appID,
          preferenceID,
          value
        });
        this.updateData(true, userId, 'sessionPreferences', sessionPreferences);
      }
    } else {
      sessionPreferences = [];
      sessionPreferences.push({
        appID,
        preferenceID,
        value
      });
      this.updateData(true, userId, 'sessionPreferences', sessionPreferences);
    }
  }
}
